<template>
  <div>
    <slot name="DoorToDoorLoading" />
    <div style="display:flex;flex-direction: row;">
      <div v-for="(item, index) in upElementBlocks" :key="index" class="section" style="margin-right: 10px;">
        <span class="title">{{ item.title }}</span>
        <el-form label-width="100px" label-position="left" style="padding-left: 15px;padding-right: 10px;">
          <el-form-item label-width="0">
            <slot v-if="item.elementNames.includes('multiplePickups')" name="multiplePickups" />
            <slot v-if="item.elementNames.includes('multipleCabinets')" name="multipleCabinets" />
          </el-form-item>
          <template v-for="elementName in item.elementNames">
            <slot v-if="elementName !== 'multiplePickups' && elementName !== 'multipleCabinets'" :name="elementName" />
          </template>
        </el-form>
      </div>
    </div>
    <template v-if="!!downElementBlock">
      <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabDischargingTruckingUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  }
}
</script>
